/** Утилиты для работы с модальными окнами */

/** Рендерит HTML-строку списка элементов
 * @param {T[]} [items=[]] - Список элементов
 * @param {(item: T) => string} renderItem - Функция рендера элемента
 * @returns {string}
 */
export function renderList(items = [], renderItem) {
  return items.map(renderItem).join("");
}

/** Преобразует значение в массив
 * @param {any} value - Значение для нормализации
 * @returns {Array}
 */
export function normalizeArray(value) {
  if (!value) return [];
  return Array.isArray(value) ? value : [value];
}

/** Очищает содержимое DOM-элемента
 * @param {HTMLElement | null} node - DOM-элемент
 * @returns {void}
 */
export function clearNode(node) {
  if (!node) return;
  node.innerHTML = "";
}

/** Переключает класс hidden у элемента
 * @param {HTMLElement | null} node - DOM-элемент
 * @param {boolean} hidden - Нужно ли скрыть элемент
 * @returns {void}
 */
export function toggleHidden(node, hidden) {
  node?.classList.toggle("hidden", hidden);
}

/** Рендерит группы ошибок/предупреждений
 * @param {Object<string, string | string[]>} [issues={}] - Список проблем
 * @returns {string}
 */
export function renderIssueGroups(issues = {}) {
  return Object.entries(issues)
    .map(
      ([phone, messages]) => `
        <div class="issue-group">
          <div class="issue-phone-title">${phone}</div>
          <ul class="issue-messages">
            ${renderList(normalizeArray(messages), message => `<li>${message}</li>`)}
          </ul>
        </div>
      `
    )
    .join("");
}
